import { debounce } from 'lodash';

import app from '../../app';

import currencyArray from '../../enums/currency';

app.factory('priceLimitService', [
  '$rootScope', '$sce', '$timeout', 'apiService', 'userService', 'adListenerService', 'categoryService',
  ($rootScope, $sce, $timeout, apiService, userService, adListenerService, categoryService) =>
{
  const watchGroup = adListenerService.createGroup('priceLimitService');
  const events = {
    START_LIMIT_UPDATING: 'priceLimitService:START_LIMIT_UPDATING',
    LIMIT_UPDATED: 'priceLimitService:LIMIT_UPDATED'
  };

  let lastApiResponse = null;
  let currentCurrency;
  let currentCategoryObj = {};
  let utilitiesPrice = 0;

  const mapCurrentCurrencyAndServerResponse = {
    'rur': 'priceLimit',
    'usd': 'priceLimitUSD',
    'eur': 'priceLimitEUR'
  };

  const getPriceLimit = () => {
    const priceLimitProperty = mapCurrentCurrencyAndServerResponse[currentCurrency];
    if (priceLimitProperty && lastApiResponse) {
      return lastApiResponse[priceLimitProperty] || 0;
    } else {
      return 0;
    }
  };

  const getCurrency = () => {
    const currencyItem = currencyArray.find(item => item.key === currentCurrency);
    return angular.isObject(currencyItem) ? currencyItem.name : '';
  };

  const getPriceLimitWithPeriod = () => {
    const { rentDuration } = currentCategoryObj;
    const period = rentDuration === 'short' ? 'сут.' : 'мес.';
    const currency = getCurrency();
    const limit = getPriceLimit();
    return $sce.trustAsHtml(`${limit} ${currency} / ${period}`);
  };

  const computeAndEmitLimit = () => {
    const {townName, districtName} = lastApiResponse || {};

    const limit = {
      townName,
      districtName,
      priceLimit: getPriceLimit(),
      priceLimitWithPeriod: getPriceLimitWithPeriod(),
      utilitiesPrice
    };

    $rootScope.$emit(events.LIMIT_UPDATED, limit);
  };

  const updateApiResponse = (response) => {
    lastApiResponse = response;
    computeAndEmitLimit();
  };

  watchGroup.$watch((ad) => ad.bargainTerms.currency, currency => {
    currentCurrency = currency;
    computeAndEmitLimit();
  })

  // Смотрим за изменением КУ
  watchGroup.$watchGroup([
    (ad) => ad.bargainTerms.utilitiesTerms.price,
    (ad) => ad.bargainTerms.utilitiesTerms.includedInPrice
  ], ([price, isIncluded]) => {
    utilitiesPrice = isIncluded ? 0 : price || 0;
    computeAndEmitLimit();
  })

  // TODO geo может мутировать, поэтому смотрим за изменением содержания объекта
  let geoComplexObject;
  watchGroup.$watch((ad) => ad.geo, debounce(newGeo => {
    $timeout(() => {
      geoComplexObject = {...newGeo};
    }, 0);
  }, 1000), true);

  watchGroup.$watchGroup([
    (ad) => ad.category,
    (ad) => ad.flatType,
    () => geoComplexObject,
    (ad) => ad.roomsCount
  ], ([category, flatType, geo, roomsCount]) => {
    /*
    теоретически нам не надо каждый раз спрашивать id пользователя, достаточно ловить событие изменения id пользователя, но его нет
     TODO создать в userService событие смены id пользователя
    */

    if (!(geo && geo.address && geo.address.length)) { // не обновлять если нет geo.address, иначе апи отдаст ошибку
      return;
    }

    currentCategoryObj = categoryService.getInfoByCategory(category);
    $rootScope.$emit(events.START_LIMIT_UPDATING);
    userService.getUser()
      .then(({userId}) => userId)
      .then(userId => {
        if (!category || !flatType || (flatType === 'rooms' && !roomsCount)) {
          return {};
        }

        const ad = adListenerService.getAd();
        const objectId = ad.id || null;

        return apiService.getPriceLimit({
          category,
          roomsCount,
          flatType,
          geo,
          userId,
          objectId
        }, {
          allowServerErrors: true
        })
      })
      .then(response => {
        updateApiResponse(response);
      })
      .catch(e => {
        updateApiResponse(null);
      });
  });

  return {
    events
  };
}]);
